<template>
  <div class="hc-banner home-border">
    <el-carousel
      :interval="3000"
      :arrow="bannerList.length === 1 ? 'never' : 'always'"
      ref="carousel"
      @click.native="gotoTemp(item)"
      @change="changeCarousel"
      trigger="click"
      :class="bannerList.length === 1 ? 'hide' : ''"
      :indicator-position="bannerList.length === 2 ? 'none' : 'outside'"
    >
      <el-carousel-item
        v-for="item in bannerList"
        :key="item.id"
        :style="{ 'background-image': `url(${item.url})` }"
      >
      </el-carousel-item>
      <div v-if="bannerList.length === 2">
        <el-carousel-item
          class="carouselItem"
          v-for="item in bannerList"
          :key="item.id"
          :style="{ 'background-image': `url(${item.url})` }"
        >
        </el-carousel-item>
      </div>
    </el-carousel>
    <!--当只有两项时显示自定义的指示器-->
    <ul
      class="
        el-carousel__indicators
        el-carousel__indicators--horizontal
        el-carousel__indicators--outside
      "
      v-if="bannerList.length === 2"
    >
      <li
        :class="index === indexActive ? 'is-active' : ''"
        class="el-carousel__indicator el-carousel__indicator--horizontal"
        v-for="(group, index) in bannerList"
        :key="index"
        @click="handleCarousel(index)"
      >
        <!-- //点击指示器，切换幻灯片的索引 -->
        <button class="el-carousel__button"></button>
      </li>
    </ul>
  </div>
</template>

<script>
import { Home } from "@/config/axios/new_api";
//HomeSetting
export default {
  data() {
    return {
      bannerList: [],
      indexActive: 0,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    changeCarousel(a) {
      if (this.bannerList.length === 2) {
        a === 2
          ? (this.indexActive = 0)
          : a === 3
          ? (this.indexActive = 1)
          : (this.indexActive = a);
      } else {
        this.indexActive = a;
      }
    },
    handleCarousel(index) {
      this.$refs.carousel.setActiveItem(index);
    },
    async getData() {
        let res = await Home.getData({ type: 1 })
        if (Array.isArray(res.data)) {
          let data = [...res.data];
          this.bannerList = data;
        }
    },

    gotoTemp() {
      let activeIndex = this.$refs.carousel.activeIndex;
      let item = this.bannerList[activeIndex];
      if (item.path_type === 1) {
        this.$router.push({
          name: "TemplateList",
          query: {
            id: item.directories_id,
            name: item.name,
            type: "banner",
          },
        });
      } else {
        this.goDesignworkbench(item, item.template_id);
      }
    },
  },
};
</script>

<style scoped>
.recommendPage .swiper-container {
  position: relative;
  width: 100%;
  height: 200px;
  background: pink;
}
.recommendPage .swiper-container .swiper-slide {
  width: 100%;
  line-height: 200px;
  background: yellowgreen;
  color: #000;
  font-size: 16px;
  text-align: center;
}
</style>
<style lang="scss">
.hc-banner {
  @include wh(664px, 304px);
  float: left;
  cursor: pointer;
  padding: 10px;
  position: relative;
  // border: 1px solid red;
  background-size: 100% 100%;
  .el-carousel__container {
    height: 284px;
    border-radius: 12px;
    overflow: hidden;
  }
  .el-carousel__indicators {
    position: absolute !important;
    width: 100%;
    left: 0;
  }
}
.is-active {
  button {
    background: #c0c4cc;
  }
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}
.el-carousel__item {
  background-size: 100% 100%;
  background-position: center;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>
